import { joinPath } from '../../core/utils';
import type { ServiceBlockOptions, ServicePaths } from './types';

/** JSON 字符串形态默认表单字段（工作负载推理/应用服务） */
export const DEFAULT_JSON_SERVICE_FIELD = '_inferenceService';

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveServicePaths(prefix: string, options?: ServiceBlockOptions): ServicePaths {
  if (options?.valueFormat === 'json-string') {
    return {
      services: options.servicesField ?? DEFAULT_JSON_SERVICE_FIELD,
    };
  }
  const segment = options?.listSegment ?? 'service';
  return {
    services: joinPath(prefix, `network.${segment}`),
  };
}
